// src/components/molecules/auth/auth-social-proof.tsx
import { cn } from "@/lib/utils";
import { StarRating } from "@/components/atoms/landing/star-rating";
import {
  TestimonialAvatarStack,
  type TestimonialAvatarItem,
} from "@/components/atoms/landing/testimonial-avatar";

type AuthSocialProofProps = {
  stars: number;
  trustLine: React.ReactNode;
  avatars: TestimonialAvatarItem[];
  className?: string;
};

/** Social-proof row tuned for the dark (#2A004F) auth aside panel. */
export function AuthSocialProof({
  stars,
  trustLine,
  avatars,
  className,
}: AuthSocialProofProps) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <TestimonialAvatarStack avatars={avatars} size={44} ringClassName="ring-brand-ink" />
      <div className="flex flex-col gap-1">
        <StarRating value={stars} size="sm" />
        <p className="text-sm text-white/70">{trustLine}</p>
      </div>
    </div>
  );
}
